"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialCategoryApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var MaterialCategoryApi = /** @class */ (function () {
    function MaterialCategoryApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询素材分类,添加素材分类
     * @method GET 查询素材分类
     * @method POST 添加素材分类
     *
     */
    MaterialCategoryApi.prototype.MaterialCategory = function () {
        return this.http
            .url("/api/MaterialCategory")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    /**
     * 修改素材分类,删除素材分类
     * @method PUT 修改素材分类
     * @method DELETE 删除素材分类
     *
     * @params id 无说明
     */
    MaterialCategoryApi.prototype.MaterialCategoryById = function (id) {
        return this.http
            .url("/api/MaterialCategory/" + id)
            .addSecurityHeaders()
            .support('PUT', 'DELETE');
    };
    MaterialCategoryApi.diOptions = di_1.default.options({
        name: "MaterialCategoryApi",
        scope: "Singleton"
    });
    return MaterialCategoryApi;
}());
exports.MaterialCategoryApi = MaterialCategoryApi;
exports.default = MaterialCategoryApi;
